import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import Uploader from 'src/constrains/SingleImageUploader';
import {
  TopLeaderBoardBanner,
  imageSetting,
  linkImage,
  linkModule,
  topLeaderBoardBanner,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/constant';
import { sectionProps } from 'src/tools/constant';
// import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';
import { editable } from '@/src/tools/contentModulesFieldName';
import { LinkModuleType } from '@/src/types/common/linkType';
import { get, set } from 'lodash';
import { useParams } from 'react-router-dom';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { topLeaderBoardBannerFields } from '../fields';
import { getEditableStatus } from '../util';

const linkN = [topLeaderBoardBanner, linkModule];
const imageN = [...linkN, linkImage];
const focusN = [...imageN, imageSetting];

const Top = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;
  const _params: any = useParams();
  const { contentUuid } = _params;
  const presetLinkTypeFilter = [
    LinkModuleType.HomePage,
    LinkModuleType.Product,
    LinkModuleType.Collection,
    LinkModuleType.ContentPage,
    LinkModuleType.LinkLibrary,
    LinkModuleType.None,
    LinkModuleType.SysModule,
  ];

  return (
    <Wrapper id={TopLeaderBoardBanner} breakpoint={breakpoint}>
      <BlockTitle
        id={TopLeaderBoardBanner}
        title={getI18n('general.hOCTitle.topLeaderBoardBanner')}
        breakpoint={breakpoint}
        onReset={() =>
          props.handleOnSectionReset(topLeaderBoardBannerFields, breakpoint)
        }
        onCopy={() =>
          props.handleOnSectionCopy(topLeaderBoardBannerFields, breakpoint)
        }
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />
      <Section {...sectionProps}>
        <Field
          name={imageN}
          dependencies={[`${TopLeaderBoardBanner}_${editable}`]}
          rules={
            [
              // {
              //   // validateTrigger: 'onSubmit',
              //   validator: async (rules: any, value: any) => {},
              // },
            ]
          }>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const e = itemWrapperErrorDisplayAdaptor(meta);
            const is_editable = getEditableStatus(
              getFieldValue,
              TopLeaderBoardBanner,
              breakpoint,
            );
            return (
              <ItemWrapper
                title={getI18n('general.tools_helper.image')}
                bottomTitle={`${getI18n(
                  'general.allowedfiletypes',
                )}: jpeg, gif, png`}
                size='small'
                {...e}>
                <Uploader
                  height={180}
                  {...props}
                  disabled={disabled || !is_editable}
                />
              </ItemWrapper>
            );
          }}
        </Field>
        <Field
          dependencies={[`${TopLeaderBoardBanner}_${editable}`]}
          shouldUpdate={(p, c) => {
            return get(p, imageN) !== get(c, imageN);
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const image = getFieldValue(imageN);
            const is_editable = getEditableStatus(
              getFieldValue,
              TopLeaderBoardBanner,
              breakpoint,
            );
            return (
              <Field name={focusN}>
                {(props, meta) => {
                  //const value = props.value;
                  const onChange = props.onChange;
                  return (
                    <FocusPoint
                      image={image}
                      disabled={disabled || !is_editable}
                      onChange={(image) => {
                        onChange(get(image, 'image.imageSetting'));
                      }}
                    />
                  );
                }}
              </Field>
            );
          }}
        </Field>
        {!disabled && (
          <Field
            name={linkN}
            dependencies={[`${TopLeaderBoardBanner}_${editable}`]}>
            {(props, meta, { getFieldValue }) => {
              const value = props.value;
              const image = getFieldValue(imageN);
              const onChange = (v, ...args) => {
                set(v, linkImage, image);
                props.onChange(v, ...args);
              };
              const is_editable = getEditableStatus(
                getFieldValue,
                TopLeaderBoardBanner,
                breakpoint,
              );
              const errors = get(meta, 'errors');
              return (
                <LinkLibraryWithSisterScScope
                  customTitle={`${getI18n('general.linkModule.Modal.link')}*`}
                  error={(errors || []).join(' ')}
                  disabled={disabled || !is_editable}
                  data={value}
                  onChange={onChange}
                  presetLinkTypeFilter={presetLinkTypeFilter}
                  salesChannelContentUuid={contentUuid}
                />
              );
            }}
          </Field>
        )}
      </Section>
    </Wrapper>
  );
};
export default Top;
